import React from 'react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-151" data-mp="30wohs94qq3vn">
      <div className="mx-auto max-w-4xl" data-id="element-152" data-mp="30zaz30hfnxr2">
        <div className="text-center" data-id="element-153" data-mp="2w5yfx5viwj5p">
          <h2 className="font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-154" data-mp="2w4wxuhg3aweh">
            <span aria-hidden="true" data-id="element-155" data-mp="2r5kfa8w94bhp">😰 </span>Vous reconnaissez-vous dans ces
            situations ?
          </h2>
          <p className="mt-3 text-sm text-ink/55" data-id="element-156" data-mp="2i6qdm442cuxa">
            Si vous avez répondu OUI à l&apos;une de ces situations — ce pack
            est pour vous.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-157" data-mp="2d9gokpkl6l9z">
          {recognizeItems.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl bg-white px-4 py-4" data-id="element-158" data-mp="bg0lgt7bbdy4">
              <span className="text-base leading-none" aria-hidden="true" data-id="element-159" data-mp="6ih7zvifv578">
                {item.emoji}
              </span>
              <span className="text-xs leading-snug text-ink/70" data-id="element-160" data-mp="3jjshd5rhx7x8">
                <span className="font-bold text-ink" data-id="element-161" data-mp="3nnqexc16aao6">{item.label} : </span>
                {item.text}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-lg font-bold italic text-brand sm:text-xl" data-id="element-162" data-mp="3elqyolxzfama">
          Vous méritez tellement mieux que cela →
        </p>
      </div>
    </section>;
}